import ModalConfirmation from './ModalConfirmation';

export default ModalConfirmation;

export interface ModalConfirmationProps {
  isVisible: boolean;
  loading?: boolean;
  title?: string;
  submitText?: string;
  updateText?: string;
  type?: string;
  description?: string;
  onConfirm: () => void;
  onCancel: () => void;
}
